import './ReassignDrawerLoader.scss';
import 'atoms/loader/Loader.scss';

export default function AvailableGroomerSelectLoader() {
  return (
    <div className="loader reassign-drawer-loader">
      {[1, 2].map((el) => (
        <div
          key={el}
          className="groomer-info-loader flex-row mb-12 p-24 border-light-purple radius-24"
        >
          <span className="loader avatar-loader" />
          <div className="flex-column ml-8 w-100">
            <span className="loader pet-name-loader mb-10" />
            <span className="loader pet-description-loader" />
          </div>
        </div>
      ))}
    </div>
  );
}
